// import { useEffect, useState } from "react"
// // import { AiOutlineMenu, AiOutlineShoppingCart } from "react-icons/ai"
// // import { BsChevronDown } from "react-icons/bs"
// import { useSelector } from "react-redux"
// import { Link, matchPath, useLocation } from "react-router-dom"

// import studyNotionLogo from "../../assets/Logo/Logo-Full-Light.png"
// import { NavbarLinks } from "../../data/navbar-links"
// // import { apiConnector } from "../../services/apiconnector"
// // import { categories } from "../../services/apis"
// // import { ACCOUNT_TYPE } from "../../utils/constants"
// import { fetchCourseCategories } from './../../services/operations/courseDetailsAPI';
// import ProfileDropDown from "../core/Auth/ProfileDropDown"
// import { AiOutlineShoppingCart } from "react-icons/ai"
// import { MdKeyboardArrowDown } from "react-icons/md"
// import MobileProfileDropDown from '../core/Auth/MobileProfileDropDown'

//  function Navbar() {


// // const Navbar = () => {
//     // console.log("Printing base url: ", import.meta.env.VITE_APP_BASE_URL);
//     const { token } = useSelector((state) => state.auth);
//     const { user } = useSelector((state) => state.profile);
//     // console.log('USER data from Navbar (store) = ', user)
//     const { totalItems } = useSelector((state) => state.cart)
//     const location = useLocation();

//     const [subLinks, setSubLinks] = useState([]);
//     const [loading, setLoading] = useState(false);


//     const fetchSublinks = async () => {
//         try {
//             setLoading(true)
//             const res = await fetchCourseCategories();
//             // const result = await apiConnector("GET", categories.CATEGORIES_API);
//             // const result = await apiConnector('GET', 'http://localhost:4000/api/v1/course/showAllCategories');
//             // console.log("Printing Sublinks result:", result);
//             setSubLinks(res);
//         }
//         catch (error) {
//             console.log("Could not fetch the category list = ", error);
//         }
//         setLoading(false)
//     }

//     // console.log('data of store  = ', useSelector((state)=> state))


//     useEffect(() => {
//         fetchSublinks();
//     }, [])


//     // when user click Navbar link then it will hold yellow color
//     const matchRoute = (route) => {
//         return matchPath({ path: route }, location.pathname);
//     }


//     // when user scroll down , we will hide navbar , and if suddenly scroll up , we will show navbar 
//     const [showNavbar, setShowNavbar] = useState('top');
//     const [lastScrollY, setLastScrollY] = useState(0);
//     useEffect(() => {
//         window.addEventListener('scroll', controlNavbar);

//         return () => {
//             window.removeEventListener('scroll', controlNavbar);
//         }
//     },)

//     // control Navbar
//     const controlNavbar = () => {
//         if (window.scrollY > 200) {
//             if (window.scrollY > lastScrollY)
//                 setShowNavbar('hide')

//             else setShowNavbar('show')
//         }

//         else setShowNavbar('top')

//         setLastScrollY(window.scrollY);
//     }



//     return (
//         <nav className={`z-[10] flex h-14 w-full items-center justify-center border-b-[1px] border-b-richblack-700 text-white translate-y-0 transition-all ${showNavbar} `}>
//              {/* <nav className={` fixed flex items-center justify-center w-full h-16 z-[10] translate-y-0 transition-all text-white ${showNavbar}`}> */}
//             <div className='flex w-11/12 max-w-maxContent items-center justify-between '>
//                 {/* logo */}
//                 <Link to="/">
//                     <img src={studyNotionLogo} width={160} height={42} loading='lazy' />
//                 </Link>

//                 {/* Nav Links - visible for only large devices*/}
//                 <ul className='hidden sm:flex gap-x-6 text-richblack-25'>
//                     {
//                         NavbarLinks.map((link, index) => (
//                             <li key={index}>
//                                 {
//                                     link.title === "Catalog" ? (
//                                         <div
//                                             className={`group relative flex cursor-pointer items-center gap-1 ${matchRoute("/catalog/:catalogName")
//                                                 ? "bg-yellow-25 text-black rounded-xl p-1 px-3"
//                                                 : "text-richblack-25 rounded-xl p-1 px-3"
//                                                 }`}
//                                         >
//                                             <p>{link.title}</p>
//                                             <MdKeyboardArrowDown />
//                                             {/* drop down menu */}
//                                             <div className="invisible absolute left-[50%] top-[50%] z-[1000] flex w-[200px] translate-x-[-50%] translate-y-[3em] 
//                                                     flex-col rounded-lg bg-richblack-5 p-4 text-richblack-900 opacity-0 transition-all duration-150 group-hover:visible 
//                                                     group-hover:translate-y-[1.65em] group-hover:opacity-100 lg:w-[300px]"
//                                             >
//                                                 <div className="absolute left-[50%] top-0 z-[100] h-6 w-6 translate-x-[80%] translate-y-[-40%] rotate-45 select-none rounded bg-richblack-5"></div>
//                                                 {loading ? (<p className="text-center ">Loading...</p>)
//                                                     : subLinks.length ? (
//                                                         <>
//                                                             {subLinks?.map((subLink, i) => (
//                                                                 <Link
//                                                                     to={`/catalog/${subLink.name
//                                                                         .split(" ")
//                                                                         .join("-")
//                                                                         .toLowerCase()}`}
//                                                                     className="rounded-lg bg-transparent py-4 pl-4 hover:bg-richblack-50"
//                                                                     key={i}
//                                                                 >
//                                                                     <p>{subLink.name}</p>
//                                                                 </Link>
//                                                             ))}
//                                                         </>
//                                                     ) : (
//                                                         <p className="text-center">No Courses Found</p>
//                                                     )}
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <Link to={link?.path}>
//                                             <p className={`${matchRoute(link?.path) ? "bg-yellow-25 text-black" : "text-richblack-25"} rounded-xl p-1 px-3 `}>
//                                                 {link.title}
//                                             </p>
//                                         </Link>)
//                                 }
//                             </li>
//                         ))}
//                 </ul>




//                 {/* Login/SignUp/Dashboard */}
//                 <div className='flex gap-x-4 items-center'>
//                     {
//                         user && user?.accountType === "Student" && (
//                             <Link to="/dashboard/cart" className="relative">
//                                 <AiOutlineShoppingCart className="text-[2.35rem] text-richblack-5 hover:bg-richblack-700 rounded-full p-2 duration-200" />
//                                 {totalItems > 0 && (
//                                     <span className="absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center overflow-hidden rounded-full bg-richblack-600 text-center text-xs font-bold text-yellow-100">
//                                         {totalItems}
//                                     </span>
//                                 )}
//                             </Link>
//                         )
//                     }
//                     {
//                         token === null && (
//                             <Link to="/login">
//                                 {/* <button className='border border-richblack-700 bg-richblack-800 px-[12px] py-[8px] text-richblack-100 rounded-md focus:outline-8 outline-yellow-50'> */}
//                                 <button className={` px-[12px] py-[8px] text-richblack-100 rounded-md 
//                                  ${matchRoute('/login') ? 'border-[2.5px] border-yellow-50' : 'border border-richblack-700 bg-richblack-800'} `}
//                                 >
//                                     Log in
//                                 </button>
//                             </Link>
//                         )
//                     }
//                     {
//                         token === null && (
//                             <Link to="/signup">
//                                 {/* <button className='border border-richblack-700 bg-richblack-800 px-[12px] py-[8px] text-richblack-100 rounded-md'> */}
//                                 <button className={` px-[12px] py-[8px] text-richblack-100 rounded-md 
//                                  ${matchRoute('/signup') ? 'border-[2.5px] border-yellow-50' : 'border border-richblack-700 bg-richblack-800'} `}
//                                 >
//                                     Sign Up
//                                 </button>
//                             </Link>
//                         )
//                     }

//                     {/* for large devices */}
//                     {token !== null && <ProfileDropDown />}

//                     {/* for small devices */}
//                     {token !== null && <MobileProfileDropDown />}

//                 </div>
//             </div>
//         </nav>
//     )
// }

// export default Navbar

import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link, matchPath, useLocation } from "react-router-dom"
import { AiOutlineShoppingCart } from "react-icons/ai"
import { MdKeyboardArrowDown } from "react-icons/md"

import studyNotionLogo from "../../assets/Logo/Logo-Full-Light.png"
import { NavbarLinks } from "../../data/navbar-links"
import { fetchCourseCategories } from "../../services/operations/courseDetailsAPI"
import ProfileDropDown from "../core/Auth/ProfileDropDown"
import MobileProfileDropDown from "../core/Auth/MobileProfileDropDown"

function Navbar() {
  const { token } = useSelector((state) => state.auth)
  const { user } = useSelector((state) => state.profile)
  const { totalItems } = useSelector((state) => state.cart)
  const location = useLocation()

  const [subLinks, setSubLinks] = useState([])
  const [loading, setLoading] = useState(false)
  const [showNavbar, setShowNavbar] = useState("top")
  const [lastScrollY, setLastScrollY] = useState(0)

  // ✅ Control Navbar scroll visibility
  const controlNavbar = () => {
    if (window.scrollY > 200) {
      if (window.scrollY > lastScrollY) setShowNavbar("hide")
      else setShowNavbar("show")
    } else {
      setShowNavbar("top")
    }
    setLastScrollY(window.scrollY)
  }

  // ✅ Fetch categories
  const fetchSublinks = async () => {
    try {
      setLoading(true)
      const res = await fetchCourseCategories()
      setSubLinks(res)
    } catch (error) {
      console.log("Could not fetch the category list = ", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSublinks()
  }, [])

  // ✅ Scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", controlNavbar)
    return () => window.removeEventListener("scroll", controlNavbar)
  }, [lastScrollY]) // dependency ensures consistent updates

  // ✅ Match route helper
  const matchRoute = (route) => {
    return matchPath({ path: route }, location.pathname)
  }

  return (
    <nav
      className={`z-[10] flex h-14 w-full items-center justify-center border-b-[1px] border-b-richblack-700 text-white translate-y-0 transition-all ${showNavbar}`}
    >
      <div className="flex w-11/12 max-w-maxContent items-center justify-between">
        {/* logo */}
        <Link to="/">
          <img
            src={studyNotionLogo}
            alt="StudyNotion Logo"
            width={160}
            height={42}
            loading="lazy"
          />
        </Link>

        {/* Nav Links */}
        <ul className="hidden sm:flex gap-x-6 text-richblack-25">
          {NavbarLinks.map((link, index) => (
            <li key={index}>
              {link.title === "Catalog" ? (
                <div
                  className={`group relative flex cursor-pointer items-center gap-1 ${
                    matchRoute("/catalog/:catalogName")
                      ? "bg-yellow-25 text-black rounded-xl p-1 px-3"
                      : "text-richblack-25 rounded-xl p-1 px-3"
                  }`}
                >
                  <p>{link.title}</p>
                  <MdKeyboardArrowDown />
                  {/* Dropdown Menu */}
                  <div
                    className="invisible absolute left-[50%] top-[50%] z-[1000] flex w-[200px] translate-x-[-50%] translate-y-[3em]
                                flex-col rounded-lg bg-richblack-5 p-4 text-richblack-900 opacity-0 transition-all duration-150 
                                group-hover:visible group-hover:translate-y-[1.65em] group-hover:opacity-100 lg:w-[300px]"
                  >
                    <div className="absolute left-[50%] top-0 z-[100] h-6 w-6 translate-x-[80%] translate-y-[-40%] rotate-45 select-none rounded bg-richblack-5" />
                    {loading ? (
                      <p className="text-center">Loading...</p>
                    ) : subLinks.length ? (
                      <>
                        {subLinks.map((subLink, i) => (
                          <Link
                            key={i}
                            to={`/catalog/${subLink.name
                              .split(" ")
                              .join("-")
                              .toLowerCase()}`}
                            className="rounded-lg bg-transparent py-4 pl-4 hover:bg-richblack-50"
                          >
                            <p>{subLink.name}</p>
                          </Link>
                        ))}
                      </>
                    ) : (
                      <p className="text-center">No Courses Found</p>
                    )}
                  </div>
                </div>
              ) : (
                <Link to={link?.path}>
                  <p
                    className={`${
                      matchRoute(link?.path)
                        ? "bg-yellow-25 text-black"
                        : "text-richblack-25"
                    } rounded-xl p-1 px-3`}
                  >
                    {link.title}
                  </p>
                </Link>
              )}
            </li>
          ))}
        </ul>

        {/* Right side buttons */}
        <div className="flex gap-x-4 items-center">
          {user && user?.accountType === "Student" && (
            <Link to="/dashboard/cart" className="relative">
              <AiOutlineShoppingCart className="text-[2.35rem] text-richblack-5 hover:bg-richblack-700 rounded-full p-2 duration-200" />
              {totalItems > 0 && (
                <span className="absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center overflow-hidden rounded-full bg-richblack-600 text-center text-xs font-bold text-yellow-100">
                  {totalItems}
                </span>
              )}
            </Link>
          )}

          {token === null && (
            <Link to="/login">
              <button
                className={`px-[12px] py-[8px] text-richblack-100 rounded-md 
                ${
                  matchRoute("/login")
                    ? "border-[2.5px] border-yellow-50"
                    : "border border-richblack-700 bg-richblack-800"
                }`}
              >
                Log in
              </button>
            </Link>
          )}

          {token === null && (
            <Link to="/signup">
              <button
                className={`px-[12px] py-[8px] text-richblack-100 rounded-md 
                ${
                  matchRoute("/signup")
                    ? "border-[2.5px] border-yellow-50"
                    : "border border-richblack-700 bg-richblack-800"
                }`}
              >
                Sign Up
              </button>
            </Link>
          )}

          {token !== null && <ProfileDropDown />}
          {token !== null && <MobileProfileDropDown />}
        </div>
      </div>
    </nav>
  )
}

export default Navbar
